import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { CurbAssetService } from '#/app/shared/services/api/curb-asset.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a curb asset exists and belongs to the tenant in the route.
 * Prevents route matching if the asset doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const curbAssetAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const curbAssetService = inject(CurbAssetService);
  const assetIdParam = _currentSnapshot?.paramMap.get('assetId') ?? '';

  return resolveResourceAccessGuardResult(assetIdParam, (assetIdSignal) =>
    curbAssetService.curbAssetResource(assetIdSignal as Signal<string>),
  );
};
